module.exports = __webpack_public_path__ + "static/media/shawn_nguyen.5dec262f.png";